<template>
  <div class="PhoneShareTab">
    <div
      class="uk-position-relative uk-visible-toggle rwd"
      tabindex="-1"
      uk-slideshow="autoplay: false;autoplay-interval: 4000;"
    >
      <ul class="uk-slideshow-items">
        <li
          class="slideshow-items video_wrap"
          v-for="item in data"
          :key="item.pageId"
        >
          <router-link
            class="txt_link"
            :to="{
              name: justify,
              params: {
                pageId: item.pageId,
                countryId: item.countryId,
              },
            }"
            style="display: block"
          >
            <div v-if="item.video" class="video">
              <div class="iframe">
                <div v-html="item.video" />
              </div>
            </div>
            <div v-else class="pic">
              <img :src="item.image" alt="國際趨勢圖片" />
            </div>
            <div class="txt_area">
              <p
                :style="{ fontSize: fontSize.p + 'em' }"
                style="text-align: left; padding: 5px 10px"
                class="message"
              >
                {{ item.title }}
              </p>
            </div>
          </router-link>
        </li>
      </ul>
      <a
        title="輪播左邊按鈕"
        class="uk-position-center-left uk-position-small"
        href="#"
        uk-slidenav-previous
        uk-slideshow-item="previous"
      >
        <span class="forFreeGo">&nbsp;</span>
      </a>
      <a
        title="輪播右邊按鈕"
        class="uk-position-center-right uk-position-small"
        href="#"
        uk-slidenav-next
        uk-slideshow-item="next"
      >
        <span class="forFreeGo">&nbsp;</span>
      </a>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "PhoneShareTab",
  props: {
    data: {
      type: Object,
    },
    justify: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    let fontSize = inject("fontSize");
    return {
      props,
      fontSize,
    };
  },
};
</script>

<style scoped lang="scss">
.PhoneShareTab {
  margin-top: 20px;
}
img {
  width: 100%;
  object-fit: cover;
}
.txt_area {
  p {
    color: $black_color;
  }
}
.pic {
  aspect-ratio: 16 / 9;
}
.uk-position-relative {
  p {
    color: $black_color;
    padding: 10px 0;
  }
  .txt_link {
    padding: 0;
    margin: 0;
  }
}
</style>
